export function filterOption (input, option) {
  return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

export function TestHaveCallBack (callback) {
  console.log('Executing shared method')
  if (callback && typeof callback === 'function') {
    callback()
  }
}
